import { AppShell } from "@chef/feature-app-shell";
import { intl } from "./Header.Intl";

interface HeaderProps {
  step: number;
}

//https://ggfrontendassets.azureedge.net/publicassets/linasmatkasse/linas-logo-red.svg
//https://ggfrontendassets.azureedge.net/publicassets/retnemt/retnemt-logo.svg
export const Header = ({ step }: HeaderProps) => {
  return (
    <AppShell.Header variant="signup" current={step} steps={[...intl.STEPS]} />
  );
};
